import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';


@Component({
  selector: 'app-impersonation-end-dialog',
  templateUrl: './impersonation-end-dialog.component.html',
  styleUrls: ['./impersonation-end-dialog.component.scss'],
  standalone: false
})
export class ImpersonationEndDialogComponent {
  token:any


  constructor(
    private dialogRef: MatDialogRef<ImpersonationEndDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { sessionDuration: string },
    public authService: AuthService

  ) {
    this.authService.token.subscribe((token: any) => {
      this.token = token;
      console.log("Token", token);
    });
  }

  close(): void {
    this.dialogRef.close(true);
  }
}